import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersService } from '@app/core/services';
import { ActivateAccount } from '@core/models';
import { PasswordRequired } from '@core/models/account/password-required';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable()
export class AccountService {

  publicPath: string;

  constructor(private configService: ConfigService, private httpClient: HttpClient, private usersService: UsersService) {
    this.publicPath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.publicPath + this.configService.appConfig.api.baseUrl;
  }

  activateAccount(activateAccountData: ActivateAccount): Promise<any> {
    return firstValueFrom(this.httpClient.post(`${this.publicPath}/activate`, activateAccountData));
  }

  isPasswordRequired(id: string): Promise<any> {
    return this.usersService.pubtk().then(r => {
      return firstValueFrom(this.httpClient.get<PasswordRequired>(`${this.publicPath}/isPasswordRequired?id=${id}`));
    });
  }
}
